import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useWeekCoverUpdateInheritance = (standalone = true) =>
    useUpdateModuleInheritance(Module.WeekCover, standalone);
